(function () {
  var STORAGE_KEY = 'jerseybirdLandingSport';

  function getStoredSport() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return '';
    }
  }

  function normalizeSport(s) {
    var value = (s || '').toString().trim().toLowerCase();
    if (!value || value === 'other') return 'soccer';
    if (value === 'ice-hockey' || value === 'ice hockey') return 'hockey';
    if (value === 'football') return 'soccer';
    if (value === 'soccer' || value === 'basketball' || value === 'baseball' || value === 'hockey') {
      return value;
    }
    return 'basketball';
  }

  function isSportPickerOpen() {
    return document.documentElement.classList.contains('landing-2026--show-picker');
  }

  function syncSportStateFromStorage() {
    if (getStoredSport()) {
      document.documentElement.classList.add('landing-2026--has-sport');
      document.documentElement.classList.remove('landing-2026--show-picker');
    } else {
      document.documentElement.classList.remove('landing-2026--has-sport');
      document.documentElement.classList.add('landing-2026--show-picker');
    }
  }

  function getFocusables(container) {
    if (!container) return [];
    var sel =
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(sel), function (el) {
      if (el.closest('[hidden]')) return false;
      if (el.getAttribute('aria-hidden') === 'true') return false;
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function announcePicker(msg) {
    var live = document.getElementById('landing-2026-picker-live');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = msg;
    }, 50);
  }

  function focusPickerFirst() {
    var picker = document.getElementById('landing-2026-picker');
    if (!picker || !isSportPickerOpen()) return;
    var list = getFocusables(picker);
    if (list.length) list[0].focus({ preventScroll: false });
  }

  function focusMainContent() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    requestAnimationFrame(function () {
      try {
        main.focus({ preventScroll: true });
      } catch (e) {
        main.focus();
      }
    });
  }

  function updatePanels(sport) {
    document.querySelectorAll('[data-jb-panel]').forEach(function (el) {
      var m = el.getAttribute('data-jb-sport');
      el.hidden = m !== sport;
    });
  }

  function heroVideoHttps(url) {
    if (!url || typeof url !== 'string') return '';
    if (url.indexOf('https://') === 0) return url;
    if (url.indexOf('http://') === 0) return 'https://' + url.slice(7);
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function pickVideoSrc(cfg) {
    if (!cfg) return '';
    var mobile =
      window.matchMedia &&
      window.matchMedia('(max-width: 768px)').matches;
    var raw =
      mobile && cfg.video_url_mobile ? cfg.video_url_mobile : cfg.video_url || '';
    return heroVideoHttps(raw);
  }

  function initHero() {
    var cfgEl = document.getElementById('landing-2026-hero-config');
    var video = document.querySelector('.landing-2026-hero__video');
    var titleEl = document.querySelector('[data-jb-hero-title]');
    var subEl = document.querySelector('[data-jb-hero-sub]');
    var btn = document.querySelector('[data-jb-hero-btn]');
    var config = {};

    if (cfgEl) {
      try {
        config = JSON.parse(cfgEl.textContent) || {};
      } catch (e) {
        config = {};
      }
    }

    function applyHero(sport) {
      var data = config[sport] || config.basketball || {};
      var src = pickVideoSrc(data);
      if (video && src) {
        video.src = src;
        video.load();
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        if (data.poster) {
          video.setAttribute('poster', data.poster);
        } else {
          video.removeAttribute('poster');
        }
      }
      if (titleEl) titleEl.textContent = data.title || '';
      if (subEl) subEl.textContent = data.subtext || '';
      if (btn) {
        var label = data.btn_label || '';
        var url = data.btn_url || '';
        btn.textContent = label;
        if (url) {
          btn.setAttribute('href', url);
          btn.removeAttribute('aria-disabled');
        } else {
          btn.setAttribute('href', '#');
          btn.setAttribute('aria-disabled', 'true');
        }
      }
    }

    function applySport(sport) {
      sport = normalizeSport(sport);
      document.documentElement.setAttribute('data-jb-sport-active', sport);
      applyHero(sport);
      updatePanels(sport);
    }

    window.jbLanding2026 = window.jbLanding2026 || {};
    window.jbLanding2026._applySport = applySport;
    window.jbLanding2026.setSport = applySport;

    // Always set hero + [data-jb-panel] visibility from storage (or default basketball).
    // First-time visitors see full page behind the picker; panels were previously all hidden.
    applySport(normalizeSport(getStoredSport()));
  }

  function initSportPickerA11y() {
    var picker = document.getElementById('landing-2026-picker');
    if (!picker) return;

    function onPickerKeydown(e) {
      if (!isSportPickerOpen()) return;
      if (e.key !== 'Tab') return;
      var focusables = getFocusables(picker);
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function onDocumentEscape(e) {
      if (!isSportPickerOpen()) return;
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      focusPickerFirst();
      announcePicker(
        'Choose a sport to continue. Use Tab to move between options.'
      );
    }

    function onFocusInDocument(e) {
      if (!isSportPickerOpen()) return;
      if (picker.contains(e.target)) return;
      window.setTimeout(function () {
        if (!isSportPickerOpen()) return;
        if (picker.contains(document.activeElement)) return;
        focusPickerFirst();
      }, 0);
    }

    picker.addEventListener('keydown', onPickerKeydown);
    document.addEventListener('keydown', onDocumentEscape, true);
    document.addEventListener('focusin', onFocusInDocument, true);

    if (isSportPickerOpen()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(focusPickerFirst);
      });
    }
  }

  function initPicker() {
    var picker = document.getElementById('landing-2026-picker');
    if (!picker) return;

    picker.querySelectorAll('[data-jb-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var raw = btn.getAttribute('data-jb-pick') || 'basketball';
        var stored = raw === 'other' ? 'soccer' : raw;
        try {
          localStorage.setItem(STORAGE_KEY, stored);
        } catch (e) {}
        document.documentElement.classList.add('landing-2026--has-sport');
        document.documentElement.classList.remove('landing-2026--show-picker');
        if (picker) {
          picker.setAttribute('aria-hidden', 'true');
        }
        if (window.jbLanding2026 && window.jbLanding2026._applySport) {
          window.jbLanding2026._applySport(stored);
        }
        focusMainContent();
      });
    });

    if (isSportPickerOpen()) {
      picker.setAttribute('aria-hidden', 'false');
    } else if (picker) {
      picker.setAttribute('aria-hidden', 'true');
    }

    initSportPickerA11y();
  }

  function initLogoModals() {
    document.querySelectorAll('[data-jb-logo-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-jb-logo-open');
        var modal = id && document.getElementById(id);
        if (modal) {
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
        }
      });
    });
    document.querySelectorAll('[data-jb-logo-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = btn.closest('.landing-2026-modal');
        if (modal) {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  function initMarqueeMobile() {
    var MOBILE_BREAKPOINT = 768;
    var DRAG_THRESHOLD = 10;          // px before a touch becomes a drag
    var IDLE_RESUME_MS = 2500;        // auto-resume after no interaction
    var FRICTION = 0.95;              // momentum decay per frame
    var MIN_VELOCITY = 0.05;          // px/ms — below this, momentum stops
    var ANIMATION_DURATION_S = 48;    // must match CSS keyframe duration

    var wrap = document.querySelector('.landing-2026-marquee-wrap');
    var track = document.querySelector('.landing-2026-marquee');
    if (!wrap || !track) return;

    var isMobile = function () {
      return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
    };

    var state = {
      mode: 'auto',           // 'auto' | 'dragging' | 'momentum' | 'idle'
      startX: 0,
      lastX: 0,
      lastT: 0,
      currentX: 0,            // current JS-driven translateX in px
      velocity: 0,            // px/ms
      moved: 0,               // total absolute movement during this touch
      idleTimer: null,
      momentumRAF: null,
      halfWidth: 0,           // width of one logo set (track is duplicated)
      pointerDown: false
    };

    function measureHalfWidth() {
      // Track contains 2 copies of the logos; half-width = one full set.
      state.halfWidth = track.scrollWidth / 2;
    }

    function readCurrentTranslateX() {
      // Read whatever transform the CSS animation is currently showing.
      var matrix = window.getComputedStyle(track).transform;
      if (!matrix || matrix === 'none') return 0;
      // matrix(a, b, c, d, tx, ty)
      var match = matrix.match(/matrix.*\((.+)\)/);
      if (!match) return 0;
      var values = match[1].split(', ');
      return parseFloat(values[4]) || 0;
    }

    function wrapX(x) {
      // Keep currentX inside [-halfWidth, 0] so the loop is seamless.
      if (state.halfWidth <= 0) return x;
      while (x <= -state.halfWidth) x += state.halfWidth;
      while (x > 0) x -= state.halfWidth;
      return x;
    }

    function applyTransform() {
      track.style.transform = 'translateX(' + state.currentX + 'px)';
    }

    function pauseAuto() {
      // Capture current animation position, then disable the CSS animation.
      state.currentX = wrapX(readCurrentTranslateX());
      track.style.animation = 'none';
      applyTransform();
    }

    function resumeAuto() {
      cancelAnimationFrame(state.momentumRAF);
      state.momentumRAF = null;
      clearTimeout(state.idleTimer);
      state.idleTimer = null;

      if (state.halfWidth <= 0) {
        track.style.animation = '';
        track.style.transform = '';
        state.mode = 'auto';
        return;
      }

      // Compute how far through the 48s keyframe currentX represents.
      // Keyframe: 0% -> 0px, 100% -> -halfWidth px. So progress = -currentX / halfWidth.
      var progress = -state.currentX / state.halfWidth;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      var delay = -(progress * ANIMATION_DURATION_S);

      // Clear inline transform, reapply animation with negative delay so it
      // picks up exactly where the user left off — no jump.
      track.style.transform = '';
      track.style.animation = 'none';
      // Force reflow so the next animation assignment actually restarts.
      void track.offsetWidth;
      track.style.animation =
        'landing-2026-marquee ' + ANIMATION_DURATION_S + 's linear infinite';
      track.style.animationDelay = delay + 's';

      state.mode = 'auto';
    }

    function scheduleIdleResume() {
      clearTimeout(state.idleTimer);
      state.idleTimer = setTimeout(function () {
        if (state.mode !== 'auto' && !state.pointerDown) {
          resumeAuto();
        }
      }, IDLE_RESUME_MS);
    }

    function runMomentum() {
      var lastFrameTime = performance.now();

      function step(now) {
        var dt = now - lastFrameTime;
        lastFrameTime = now;

        state.currentX += state.velocity * dt;
        state.currentX = wrapX(state.currentX);
        applyTransform();

        // Decay: friction is per-frame, normalize to dt.
        state.velocity *= Math.pow(FRICTION, dt / 16.67);

        if (Math.abs(state.velocity) < MIN_VELOCITY) {
          state.momentumRAF = null;
          state.velocity = 0;
          state.mode = 'idle';
          scheduleIdleResume();
          return;
        }

        state.momentumRAF = requestAnimationFrame(step);
      }

      state.mode = 'momentum';
      state.momentumRAF = requestAnimationFrame(step);
    }

    function onTouchStart(e) {
      if (!isMobile()) return;
      if (e.touches.length !== 1) return;

      state.pointerDown = true;
      state.moved = 0;
      state.startX = e.touches[0].clientX;
      state.lastX = state.startX;
      state.lastT = performance.now();
      state.velocity = 0;

      // Cancel any in-flight momentum and clear idle timer.
      cancelAnimationFrame(state.momentumRAF);
      state.momentumRAF = null;
      clearTimeout(state.idleTimer);
      state.idleTimer = null;

      // Don't pause yet — wait for actual drag past threshold so taps still open modals.
    }

    function onTouchMove(e) {
      if (!isMobile()) return;
      if (!state.pointerDown) return;
      if (e.touches.length !== 1) return;

      var x = e.touches[0].clientX;
      var dx = x - state.lastX;
      var now = performance.now();
      var dt = now - state.lastT;

      state.moved += Math.abs(dx);

      if (state.mode !== 'dragging' && state.moved > DRAG_THRESHOLD) {
        // Crossed the threshold — switch into drag mode.
        measureHalfWidth();
        pauseAuto();
        state.mode = 'dragging';
      }

      if (state.mode === 'dragging') {
        // Prevent the page from vertical-scrolling while dragging horizontally.
        if (e.cancelable) e.preventDefault();

        state.currentX = wrapX(state.currentX + dx);
        applyTransform();

        if (dt > 0) {
          // Smooth velocity a bit so flicks aren't jittery.
          var instantV = dx / dt;
          state.velocity = state.velocity * 0.3 + instantV * 0.7;
        }
      }

      state.lastX = x;
      state.lastT = now;
    }

    function onTouchEnd() {
      if (!state.pointerDown) return;
      state.pointerDown = false;

      if (state.mode !== 'dragging') {
        // Was a tap — let the click through to open the modal. Nothing to do.
        return;
      }

      // Was a drag — start momentum or schedule idle resume.
      if (Math.abs(state.velocity) > MIN_VELOCITY) {
        runMomentum();
      } else {
        state.mode = 'idle';
        scheduleIdleResume();
      }
    }

    function onClickCapture(e) {
      // If the touch turned into a drag, swallow the click so the modal doesn't open.
      if (state.moved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        // Reset for next interaction.
        state.moved = 0;
      }
    }

    function onOutsideTouch(e) {
      if (!isMobile()) return;
      if (state.mode === 'auto') return;
      if (wrap.contains(e.target)) return;
      // Tap outside the marquee — resume immediately.
      resumeAuto();
    }

    // Touch listeners on the wrap (passive: false on move so we can preventDefault).
    wrap.addEventListener('touchstart', onTouchStart, { passive: true });
    wrap.addEventListener('touchmove', onTouchMove, { passive: false });
    wrap.addEventListener('touchend', onTouchEnd, { passive: true });
    wrap.addEventListener('touchcancel', onTouchEnd, { passive: true });

    // Capture-phase click handler so we can intercept before initLogoModals fires.
    wrap.addEventListener('click', onClickCapture, true);

    // Document-level listener for taps outside the marquee.
    document.addEventListener('touchstart', onOutsideTouch, { passive: true });

    // If the viewport resizes (e.g., orientation change), recompute the half-width.
    window.addEventListener('resize', function () {
      if (state.mode !== 'auto') {
        measureHalfWidth();
      }
    });

    // Initial measurement after images load (so scrollWidth is accurate).
    if (document.readyState === 'complete') {
      measureHalfWidth();
    } else {
      window.addEventListener('load', measureHalfWidth);
    }
  }

  function boot() {
    syncSportStateFromStorage();
    initHero();
    initPicker();
    initLogoModals();
    initMarqueeMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();